import React from 'react';

interface SortIconProps {
  className?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
}

const SortIcon: React.FC<SortIconProps> = ({
  className = '',
  width = 12,
  height = 12,
  onClick
}) => {
  return (
    <div
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default'
      }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10.9684 3.43207L9.46836 1.93207C9.4269 1.89062 9.37717 1.8578 9.32217 1.83495C9.21216 1.78939 9.08823 1.78939 8.97822 1.83495C8.92329 1.8578 8.87349 1.89061 8.83203 1.93207L7.33203 3.43207C7.15625 3.60785 7.15625 3.89262 7.33203 4.0684C7.50781 4.24418 7.79258 4.24418 7.96836 4.0684L8.7002 3.33656L8.7002 9.75023C8.7002 9.99867 8.90176 10.2002 9.1502 10.2002C9.39864 10.2002 9.6002 9.99867 9.6002 9.75023L9.6002 3.33656L10.332 4.0684C10.4199 4.15629 10.5348 4.20024 10.6502 4.20024C10.7656 4.20024 10.8805 4.1563 10.9684 4.0684C11.1441 3.89262 11.1441 3.60785 10.9684 3.43207Z"
          fill="#292929"
        />
        <path
          d="M4.3502 3.9L1.6502 3.9C1.40176 3.9 1.2002 3.69844 1.2002 3.45C1.2002 3.20156 1.40176 3 1.6502 3L4.3502 3C4.59863 3 4.8002 3.20156 4.8002 3.45C4.8002 3.69844 4.59863 3.9 4.3502 3.9Z"
          fill="#292929"
        />
        <path
          d="M5.5502 6.2999L1.6502 6.2999C1.40176 6.2999 1.2002 6.09834 1.2002 5.8499C1.2002 5.60147 1.40176 5.3999 1.6502 5.3999L5.5502 5.3999C5.79863 5.3999 6.0002 5.60147 6.0002 5.8499C6.0002 6.09834 5.79863 6.2999 5.5502 6.2999Z"
          fill="#292929"
        />
        <path
          d="M6.7502 8.6998H1.6502C1.40176 8.6998 1.2002 8.49824 1.2002 8.2498C1.2002 8.00137 1.40176 7.7998 1.6502 7.7998L6.7502 7.7998C6.99863 7.7998 7.2002 8.00137 7.2002 8.2498C7.2002 8.49824 6.99863 8.6998 6.7502 8.6998Z"
          fill="#292929"
        />
      </svg>
    </div>
  );
};

export default SortIcon;
